module.exports = __webpack_public_path__ + "img/base_activites_info.3ba16181.svg";